import router from "@/router";

export default {
  processErrorMessage(error) {
    let err = ["Something went wrong while processing request!"];

    if (error.response) {
      let status_code = error.response.data.status_code || error.response.status;
      if (status_code == 401) {
        return router.push({ name: "login" });
      } else if (status_code == 404) {
        err = ["Data not found!"];
        return err;
      } else if (status_code == 503) {
        let err = [error.response.data.message];
        return router.push({ name: "page-error-503" });
      } else if (status_code == 524) {
        let err = ["Timeout error while processing request!"];
        return err;
      } else {
        let err = error.response.data.message
          ? [error.response.data.message]
          : ["Something went wrong while processing request!"];
        return err;
      }
    } else {
      console.log(error);
      return err;
    }
  },
};
